import { ConsultationHistoryItem } from '../pages/consultation-history/types';

export const exportToExcel = (data: ConsultationHistoryItem[], filename: string = 'consultas') => {
  const headers = [
    'ID Consulta',
    'Empresa',
    'CNPJ',
    'Data Criação',
    'Status',
    'Produtos',
    'Total Impostos (R$)',
    'UF Origem',
    'UF Destino',
    'CFOP',
    'Regime Tributário',
    'Atualização',
    'Criado Por',
    'Observações'
  ];

  const rows = data.map(item => [
    item.consultationId,
    item.companyName,
    item.cnpj,
    new Date(item.createdDate).toLocaleDateString('pt-BR'),
    getStatusLabel(item.status),
    item.productCount.toString(),
    item.totalTaxAmount.toLocaleString('pt-BR', { minimumFractionDigits: 2 }),
    item.ufOrigin,
    item.ufDestination,
    item.cfop,
    getTaxRegimeLabel(item.taxRegime),
    getDataFreshnessLabel(item.apiDataFreshness),
    item.createdBy,
    item.notes || ''
  ]);

  const csvContent = [
    headers.join('\t'),
    ...rows.map(row => row.join('\t'))
  ].join('\n');

  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const exportToCSV = (data: ConsultationHistoryItem[], filename: string = 'consultas') => {
  const headers = [
    'ID Consulta',
    'Empresa',
    'CNPJ',
    'Data Criação',
    'Status',
    'Produtos',
    'Total Impostos',
    'UF Origem',
    'UF Destino',
    'CFOP',
    'Regime Tributário',
    'Atualização',
    'Criado Por',
    'Observações'
  ];

  const escapeCsvValue = (value: string) => {
    if (value.includes(',') || value.includes('"') || value.includes('\n')) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  };

  const rows = data.map(item => [
    escapeCsvValue(item.consultationId),
    escapeCsvValue(item.companyName),
    escapeCsvValue(item.cnpj),
    escapeCsvValue(new Date(item.createdDate).toLocaleDateString('pt-BR')),
    escapeCsvValue(getStatusLabel(item.status)),
    item.productCount.toString(),
    item.totalTaxAmount.toFixed(2),
    escapeCsvValue(item.ufOrigin),
    escapeCsvValue(item.ufDestination),
    escapeCsvValue(item.cfop),
    escapeCsvValue(getTaxRegimeLabel(item.taxRegime)),
    escapeCsvValue(getDataFreshnessLabel(item.apiDataFreshness)),
    escapeCsvValue(item.createdBy),
    escapeCsvValue(item.notes || '')
  ]);

  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.join(','))
  ].join('\n');

  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const getStatusLabel = (status: string): string => {
  const statusMap: { [key: string]: string } = {
    success: 'Sucesso',
    api_error: 'Erro API',
    validation_error: 'Erro Validação',
    processing: 'Processando',
    pending: 'Pendente'
  };
  return statusMap[status] || status;
};

const getTaxRegimeLabel = (regime: string): string => {
  const regimeMap: { [key: string]: string } = {
    lucro_real: 'Lucro Real',
    lucro_presumido: 'Lucro Presumido',
    simples_nacional: 'Simples Nacional'
  };
  return regimeMap[regime] || regime;
};

const getDataFreshnessLabel = (freshness: string): string => {
  const freshnessMap: { [key: string]: string } = {
    current: 'Atualizado',
    outdated: 'Desatualizado',
    requires_update: 'Requer Atualização'
  };
  return freshnessMap[freshness] || freshness;
};